// 权限api

import {baseRequest} from "./base";

/**
 * @desc 查询权限列表
 */
function getAccPermissionList(params) {
  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/accPermission/'
  return baseRequest(tempUrl, 'get', params);
}

/**
 * @desc 新增权限
 */
function addPermission(params) {
  return baseRequest(`/api/pcWeb/accPermission/create`, 'post', params);
}

/**
 * @desc 删除权限
 */
function deletePermission(id) {
  return baseRequest(`/api/pcWeb/accPermission/delete/${id}`, 'get');
}

/**
 * @desc 修改权限
 */
function updatePermission(params) {
  return baseRequest(`/api/pcWeb/accPermission/update`, 'post', params);
}
function treeData(data, j, level, parent) {
  //  递归循环权限菜单 处理可显示渲染的菜单数据
  if (typeof level == 'undefined') {
    level = 1
  }
  data.level = level
  if (level==0) {
    data.id = ''
  } else if (level == 1) {//j从1开始
    data.id = j + ''
  } else if (level > 1) {
    data.id = parent.id + '-' + j
  }
  
  data.name = data.permName
  data.icon = data.permCode
  data.parent = parent
  if (data.children && data.children.length > 0) {
    let max = data.children.length;
    for (let i = 0; i < max; i++)
      treeData(data.children[i], i + 1, level + 1, data)
  }
}
/**
 * @desc 查询我的权限列表
 */
function listMyPerms(id, params) {
  return new Promise((resolve, reject) => {
    baseRequest(`/api/pcWeb/accPermission/listMyPerms`, 'get').then((res) => {
      if (res.code == 0) {
        let menuRoot = {
          level : 0,
          id : 0,
          permName : "",
          permCode : "",
          children : res.data,
          parent : null
        }//避免在多处循环
        treeData(menuRoot, -1, 0, null);
        resolve(res);
        return;
      }
      reject(res)
    });
  });
}


/**
 * @desc 查询全部权限
 */
function getAllPermissionList(id, params) {
  return baseRequest(`/api/pcWeb/accPermission/listAll`, 'get');
}


export default {
  getAccPermissionList: getAccPermissionList,
  addPermission: addPermission,
  deletePermission: deletePermission,
  updatePermission: updatePermission,
  listMyPerms:listMyPerms,
  getAllPermissionList:getAllPermissionList
}

